import { ROUTES } from "./routes";

export const PRIVACY_POLICY = ROUTES.privacy;
